var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeWhite = function SvgYoutubeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.377 4.11a3.006 3.006 0 0 1 2.121 2.123C24 8.104 24 12.009 24 12.009s0 3.905-.502 5.777a3.005 3.005 0 0 1-2.121 2.122c-1.872.501-9.377.501-9.377.501s-7.505 0-9.377-.501a3.005 3.005 0 0 1-2.121-2.122C0 15.914 0 12.009 0 12.009s0-3.905.502-5.776A3.006 3.006 0 0 1 2.623 4.11C4.495 3.609 12 3.609 12 3.609s7.505 0 9.377.502Zm-5.542 7.9L9.6 15.61v-7.2l6.235 3.6Z",
    fill: "currentColor"
  })));
};
export default SvgYoutubeWhite;